var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysError = function SvgSysError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.438,
    cy: 7.563,
    r: 4.813,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M8.004 15.004a6.93 6.93 0 0 1-4.971-2.031 6.573 6.573 0 0 1-2.03-4.97 6.798 6.798 0 0 1 2.03-4.97 6.623 6.623 0 0 1 4.971-2.03 6.934 6.934 0 0 1 4.97 2.03 6.583 6.583 0 0 1 2.03 4.97 6.921 6.921 0 0 1-2.031 4.97 6.571 6.571 0 0 1-4.969 2.03Zm0-6.09 1.819 1.819.981-.98-1.82-1.82 1.82-1.819-.981-.982-1.819 1.821-1.821-1.82-.98.981 1.82 1.819-1.82 1.82.98.98 1.821-1.819Z"
  })));
};
export default SvgSysError;